import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Container } from '../../layout/primitives';
import { Button } from '../../ui/Button';

interface ChatbotConfigHeaderProps {
  chatbot: any;
  onBack: () => void;
}

const ChatbotConfigHeader: React.FC<ChatbotConfigHeaderProps> = ({ chatbot, onBack }) => {
  return (
    <div className="border-b border-agentic-gray-200/60">
      <Container size="content" className="py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Button tone="muted-text"
              onClick={onBack}
              className="p-2 transition-colors"
              aria-label="Go back"
            >
              <ArrowLeftIcon className="h-5 w-5" />
            </Button>
            <div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-agentic-text-primary via-agentic-primary-blue to-agentic-accent-purple bg-clip-text text-transparent">
                {chatbot?.name || 'Chatbot'}
              </h1>
              <p className="mt-1 text-agentic-text-secondary">{chatbot?.description}</p>
            </div>
          </div>
          <div className="text-sm text-agentic-text-secondary">
            Last updated:{' '}
            {chatbot?.updatedAt
              ? new Date(chatbot.updatedAt).toLocaleString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : 'N/A'}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ChatbotConfigHeader;
